import { useCallback, useState } from "react";
import { errorData, fetchingData, noData, readyData, } from "../../components/data-loader/DataLoaderTypes";
export function useRequestedData(request, callbacks) {
    if (callbacks === void 0) { callbacks = {}; }
    var _a = useState(noData()), data = _a[0], setData = _a[1];
    var transformData = callbacks.transformData, successCallback = callbacks.successCallback, errorCallback = callbacks.errorCallback;
    var fetchData = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        setData(fetchingData());
        request.apply(void 0, args).then(function (result) {
            setData(readyData(transformData ? transformData(result) : result));
            if (successCallback) {
                successCallback(result);
            }
        })
            .catch(function (error) {
            setData(errorData(error.message));
            if (errorCallback) {
                errorCallback(error.message);
            }
        });
    }, [errorCallback, request, successCallback, transformData]);
    return {
        data: data,
        setData: setData,
        fetchData: fetchData,
    };
}
